import { Component, EventEmitter, Input, Output } from '@angular/core';

type DropdownOption = { name: string };
@Component({
  selector: 'dal-shared-ui-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrl: './drop-down.component.scss',
})
export class DropDownComponent<T extends DropdownOption = DropdownOption> {

  @Input() values: T[] | null = [];
  @Input() icon: string;
  @Input() heading: string;
  @Input() selected: string;
  @Input() label: string;
  @Input() showClearOption: boolean = false;
  @Input() showInfo = false
  @Input() infoText: string;
  @Output() SelectionEvent: EventEmitter<T | undefined> = new EventEmitter();

  onSelectionChange(event: { value: string }) {
    this.selected = event.value;
    const option = this.values?.find((option) => option.name === event.value)
    this.SelectionEvent.emit(option);
  }

  changeTemplate(event: string) {
    this.selected = event;
  }
}
